<div *ngIf="mobileDocument || contracts.length > 0" class="combo-selector-dropdown">
  <button
    class="selector-btn"
    [class.active]="isDropdownOpen"
    [class.has-multiple]="hasMultipleOptions"
    [class.is-loading]="isLoading"
    [disabled]="isLoading"
    (click)="toggleDropdown()"
  >
    <span
      class="mdn-Icon-empresa mdn-Icon--md"
      [attr.aria-label]="'components.cnpjSelector.ariaLabelCompany' | i18n"
    ></span>
    <span class="selector-text">
      <ng-container *ngIf="showContractLabel; else mobileLabel">
        {{ fixaContractLabel(selectedContractId) }}
      </ng-container>
      <ng-template #mobileLabel>
        <ng-container *ngIf="mobileDocument; else fallbackContractLabel">
          {{ mobileDocument | cnpj }}
        </ng-container>
        <ng-template #fallbackContractLabel>
          {{ fixaContractLabel(selectedContractId || contracts[0].customerAccountId) }}
        </ng-template>
      </ng-template>
    </span>
    <span *ngIf="isLoading" class="selector-spinner" aria-hidden="true"></span>
    <span *ngIf="!isLoading" class="dropdown-icon mdn-Icon-baixo" aria-hidden="true"></span>
  </button>

  <div class="dropdown-menu" [class.open]="isDropdownOpen">
    <div class="dropdown-content">
      <div class="dropdown-title">
        {{ 'components.comboSelector.changeProduct' | i18n }}
      </div>
      <div class="dropdown-section" *ngIf="mobileDocument">
        <div class="section-title">
          <span class="mdn-Icon-celular mdn-Icon--md" aria-label="celular"></span>
          <span>{{ 'components.comboSelector.mobile' | i18n }}</span>
        </div>

        <div class="card-item" [class.is-disabled]="isLoading" (click)="onSelectMobile()">
          <div class="card-left">
            <div class="primary">{{ mobileDocument | cnpj }}</div>
            <div class="secondary">{{ companyName }}</div>
          </div>
          <span class="chevron mdn-Icon-direita" aria-hidden="true"></span>
        </div>
      </div>

      <div class="dropdown-section" *ngIf="contracts.length > 0">
        <div class="section-title">
          <span class="mdn-Icon-modem mdn-Icon--md" aria-label="modem"></span>
          <span>{{ 'components.comboSelector.fixa' | i18n }}</span>
        </div>

        <div class="card-item" *ngFor="let c of contracts" [class.is-disabled]="isLoading" (click)="onSelectContract(c)">
          <div class="card-left">
            <div class="primary">
              {{ fixaContractLabel('' + c.customerAccountId) }}
            </div>
            <div class="secondary">
              <span>{{ c.status }}</span>
              <span>•</span>
              <span>{{ c.sourceSystemDescription }}</span>
            </div>
          </div>
          <span class="chevron mdn-Icon-direita" aria-hidden="true"></span>
        </div>
      </div>
      <button class="show-all" type="button" (click)="onShowAllProducts()">
        {{ 'components.comboSelector.showAllProducts' | i18n }}
        <span class="show-all-icon mdn-Icon-direita" aria-hidden="true"></span>
      </button>
    </div>
  </div>
</div>
